/**
 * @generated SignedSource<<08060add23e9855b0af1bdd57c08d4b1>>
 * @relayHash 7653330fe77d5a9f4d6a8d3529559b3e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 65ccbf7e5f79b9f99519b702745550e8e5f7d55589f62713d36e304750f2cdce

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CapacityPeopleViewContentQuery } from './CapacityPeopleViewContentQuery.graphql';

import isAiImportEnabled_provider from '../../../../../../../platform/packages/capacity-planning/capacity-planning-core/src/ui/capacity-planning-core/table/common/cell/contribution-cell/../../../../../../is-ai-import-enabled.relayprovider';
import isBulkEditEnabled_provider from '../../../../../../../platform/packages/capacity-planning/capacity-planning-core/src/ui/capacity-planning-core/table/people/row/people-view-body-row/../../../../../../is-bulk-edit-enabled.relayprovider';
import isReorderingEnabled_provider from '../../../../../../../platform/packages/capacity-planning/capacity-planning-core/src/ui/capacity-planning-core/table/people/row/people-view-body-row/../../../../../../is-reordering-enabled.relayprovider';

const node: PreloadableConcreteRequest<CapacityPeopleViewContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "65ccbf7e5f79b9f99519b702745550e8e5f7d55589f62713d36e304750f2cdce",
    "metadata": {},
    "name": "CapacityPeopleViewContentQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__isaiimportenabledrelayprovidertsx": isAiImportEnabled_provider,
      "__relay_internal__pv__isreorderingenabledrelayprovidertsx": isReorderingEnabled_provider,
      "__relay_internal__pv__isbulkeditenabledrelayprovidertsx": isBulkEditEnabled_provider
    }
  }
};

export default node;
